import React, { useMemo } from 'react';
import { useStore } from '../context/StoreContext';
import { AUTO_TAG_SUGGESTION_LIMIT, AUTO_TAG_MIN_TOKEN_LEN } from '../constants';

const TagSuggestions = ({ note, onAddTag }) => {
  const { notes } = useStore();

  const suggestions = useMemo(() => {
    if (!note) return [];
    
    // 1. Get all existing tags from all notes
    const allTags = [...new Set(notes.flatMap(n => n.tags || []))];
    
    // 2. Tokenize note content
    const content = `${note.title} ${note.bodyText} ${note.checklistItems?.map(i => i.text).join(' ')}`.toLowerCase();
    const tokens = content.split(/\W+/).filter(t => t.length >= AUTO_TAG_MIN_TOKEN_LEN);

    // 3. Find existing tags that appear in content tokens
    const foundTags = allTags.filter(tag => 
      tokens.includes(tag.toLowerCase()) && !note.tags?.includes(tag)
    );

    // 4. Suggest common tokens as new tags (optional, but limited)
    const freq = {};
    tokens.forEach(t => { freq[t] = (freq[t] || 0) + 1; });
    const commonTokens = Object.entries(freq)
      .sort((a,b) => b[1] - a[1])
      .map(e => e[0])
      .filter(t => !allTags.includes(t) && !note.tags?.includes(t))
      .slice(0, 3);

    return [...new Set([...foundTags, ...commonTokens])].slice(0, AUTO_TAG_SUGGESTION_LIMIT);
  }, [note, notes]);

  if (suggestions.length === 0) return null;

  return (
    <div className="mt-4 flex flex-wrap items-center gap-2">
      <span className="text-[10px] font-bold uppercase text-gray-400">Suggestions:</span>
      {suggestions.map(tag => (
        <button
          key={tag}
          onClick={() => onAddTag(tag)}
          className="text-xs px-2 py-0.5 bg-blue-50 text-blue-600 rounded-md hover:bg-blue-100 transition"
        >
          +{tag}
        </button>
      ))}
    </div>
  );
};

export default TagSuggestions;